<script>
	import { onDestroy, onMount } from "svelte";
	import { Route, navigateTo } from "svelte-router-spa";
	import { PRConnect } from "@projectroom/ui-lib";
	import { _ } from "svelte-i18n";
	import { iframeRefStore } from "./store/iframe-store.js";
	import { setContext } from "svelte";
	import { isPublishPopup, isRevision } from "./store/builder-store.js";
	import { planStore, isCreepong } from "./store/plan-store";
	import { ThemeToggle, Dialog, Button, Input, Switch, Tabs } from "./../lib/ui";
	import AccountMenu from "./common/AccountMenu.svelte";

	export let currentRoute;
	export let params;

	let pageUrl;
	let qrUrl;
	let title = "";
	let autoSaveFlag = false;
	let chatId;
	let isLoaded;
	let isHomeOpenFlag;
	let isCharacterUniverseOpenFlag;
	let iframeRef;
	let unsubscribe;
	let isDarkModeFlag;
	onMount(async () => {
		iframeRefStore.get();
		unsubscribe = iframeRefStore.subscribe((ref) => {
			iframeRef = ref;
		});
		await planStore.init();
		chatId = currentRoute.namedParams.chatId;
		PRConnect.send("/api/Chat/getChatInfo", { chatId }, async (data) => {
			if (data.header.status === "success") {
				pageUrl = data.result.chatInfo.pageUrl;
				qrUrl = `https://api.qrserver.com/v1/create-qr-code/?data=${pageUrl}&amp;size=100x100`;
				title = data.result.chatInfo.title;
				isHomeOpenFlag = data.result.chatInfo.aiHomeOpenFlag;
				isCharacterUniverseOpenFlag =
					data.result.chatInfo.characterUniverseOpenFlag;
				isDarkModeFlag = data.result.chatInfo.darkModeFlag;
				handleAutoSave();
				isLoaded = true;
			}
		});
		// const unSubpublish = isPublishPopup.subscribe(message => {
		// });
	});

	onDestroy(() => {
		unsubscribe();
		clearTimeout(publishedTimer);
	});

	// const clickPosting = () => {
	//     popupPosting = false;
	//     dropdownLink = true;
	//     PRConnect.send("/api/Post/postChangeBotData", {botId}, data => {
	//         if( data.header.status === "success") {
	//             console.log("postChangeBotData success");
	//         }
	//     });
	// }

	// const clickDisposal = () => {
	//     popupDisposal = false;
	//     PRConnect.send("/api/Post/disposalChangeBotData", {botId}, data => {
	//         if( data.header.status === "success") {
	//             console.log("disposalChangeBotData success", data);
	//             location.reload();
	//         }
	//     });
	// }

	// const clickOutLayer = () => {
	//     dropdownLink = false;
	//     popupPosting = false;
	//     popupDisposal = false;
	// }

	// const clickDisposalButton = () => {
	//     if (!isLatestUpdated) {
	//         return;
	//     }
	//     popupDisposal = true
	// }

	// const clickCopy = () => {
	//     navigator.clipboard.writeText(pageUrl).then(
	//         () => {
	//             // successMesage = "clipboard에 복사되었습니다.";
	//             console.log("clipboard 복사 성공");
	//         },
	//     );
	// }

	const handleAutoSave = () => {
		autoSaveFlag = true;
		setTimeout(() => {
			autoSaveFlag = false;
		}, 1500);
	};

	// 빌더("AI챗 생성"/"게시하기" 버튼)가 넘겨준 성공 콜백. 게시가 실제로 끝난 뒤에만 호출한다.
	let onPublishSuccess = null;
	// 게시 직후 팝업 상단에 잠깐 띄우는 완료 안내.
	let publishedJustNow = false;
	let publishedTimer;

	// isPosted : 게시된적 있는지
	const clickPosting = ({ isPosted = true, onSuccess = null } = {}) => {
		onPublishSuccess = onSuccess;
		// 게시된적 있으면 팝업만 키고, 없으면 post를 하면서 팝업을 키기
		// 크리퐁은 팝업없이 그냥 post만 하기
		if (isPosted) {
			if ($isCreepong) {
				doPosting({ isPosted });
			} else {
				isPublishPopup.set(true);
			}
		} else {
			isPublishPopup.set(false);
			doPosting({ isPosted });
		}
	};

	// 게시 실패를 사용자에게 알린다.
	// 예전엔 요청 전에 isRevision 을 먼저 내려버리고 실패 시 조용히 되돌리기만 해서,
	// 서버에서 게시가 통째로 실패해도(예: CHATS/CHATS_C 스키마 불일치 → SQL 1136)
	// 화면상으론 게시된 것처럼 보였다. → 성공했을 때만 배지를 내리고, 실패는 반드시 말한다.
	const failPosting = (data) => {
		isRevision.update(() => true);
		onPublishSuccess = null;
		alert(
			data?.header?.message
				? `게시에 실패했어요.\n${data.header.message}`
				: "게시에 실패했어요. 잠시 후 다시 시도해주세요.",
		);
	};

	const doPosting = ({ isPosted = true } = {}) => {
		PRConnect.send(
			"/api/Post/postChangeChatData",
			{ chatId },
			(data) => {
				if (data.header.status !== "success") {
					failPosting(data);
					return;
				}
				console.log("postChange success");
				// 크리퐁 & 첫 반영
				if ($isCreepong && !isPosted) {
					window.parent.postMessage(
						{ type: "chatPublish", chatId },
						"*",
					);
					// 크리퐁 & 수정
				} else if ($isCreepong && isPosted) {
					window.parent.postMessage(
						{ type: "chatModify", chatId },
						"*",
					);
				}
				isRevision.update(() => false);
				if (onPublishSuccess) {
					onPublishSuccess();
					onPublishSuccess = null;
				}
				// 게시가 끝나면 여기서 멈추지 않고 게시 설정(주소/QR/공개여부)까지 이어준다.
				// 예전엔 첫 게시가 성공해도 화면에 아무 변화가 없어서 "게시가 안 된다"로 보였다.
				if (!$isCreepong) {
					isPublishPopup.set(true);
					publishedJustNow = true;
					clearTimeout(publishedTimer);
					publishedTimer = setTimeout(
						() => (publishedJustNow = false),
						4000,
					);
				}
			},
			failPosting,
		);
	};

	const changeHomeOpenFlag = () => {
		isHomeOpenFlag = isHomeOpenFlag === "Y" ? "N" : "Y";
		modifyChatPublishConfig();
	};

	const changeCharacterUniverseOpenFlag = () => {
		isCharacterUniverseOpenFlag =
			isCharacterUniverseOpenFlag === "Y" ? "N" : "Y";
		modifyChatPublishConfig();
	};

	const modifyChatPublishConfig = () => {
		PRConnect.send(
			"/api/Chat/modifyChatOpenFlag",
			{
				chatId,
				aiHomeOpenFlag: isHomeOpenFlag,
				darkModeFlag: isDarkModeFlag,
				characterUniverseOpenFlag: isCharacterUniverseOpenFlag,
			},
			(data) => {
				isRevision.update(() => true);
				if (data.header.status === "success") {
					console.log("change homeOpenFlag success");
					iframeRef.contentWindow.location.reload();
					isRevision.update(() => true);
				}
			},
			(error) => {
				console.error(error);
				isRevision.update(() => false);
			},
		);
	};

	const clickCopy = () => {
		navigator.clipboard.writeText(pageUrl).then(() => {
			// successMesage = "clipboard에 복사되었습니다.";
			console.log("clipboard 복사 성공");
		});
	};

	// 화이트/블랙을 값으로 지정한다. 예전 체크박스는 둘 다 토글이라
	// 이미 선택된 쪽을 다시 눌러도 반대로 뒤집혔다.
	const setDarkMode = (flag) => {
		if (isDarkModeFlag === flag) return;
		isDarkModeFlag = flag;
		modifyChatPublishConfig();
	};
	setContext("clickPosting", clickPosting);

	const deactivePublishPopup = () => {
		isPublishPopup.set(false);
		publishedJustNow = false;
		onPublishSuccess = null;
	};
</script>

<div class="lite-wrap" on:click={deactivePublishPopup}>
	{#if !$isCreepong}
		<header
			class="builder-topbar tw-fixed tw-inset-x-0 tw-top-0 tw-z-50 tw-flex tw-h-14 tw-items-center tw-justify-between tw-border-b tw-border-border tw-bg-sidebar tw-font-sans" style="padding-inline: max(1rem, calc((100vw - var(--app-max-w, 1920px)) / 2))"
			on:click={deactivePublishPopup}
		>
			<div class="tw-flex tw-items-center tw-gap-2.5">
				<button
					type="button"
					class="tw-flex tw-h-8 tw-w-8 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-lg tw-transition-colors hover:tw-bg-muted"
					on:click={() => navigateTo("/main")}
					aria-label="아바톡 홈"
					title="아바톡 홈"
				>
					<img class="tw-h-6 tw-w-6" src="/static/images/avatalk-charecter-pink.svg" alt="아바톡" />
				</button>
				<div class="tw-h-4 tw-w-px tw-bg-border" />
				<div class="tw-flex tw-items-center tw-gap-1.5 tw-text-sm">
					<span class="tw-font-semibold tw-text-foreground">{title || "AI챗"}</span>
					<span class="tw-text-muted-foreground">/ 캐릭터 빌더</span>
				</div>
			</div>
			<div class="tw-flex tw-items-center tw-gap-2">
				<!-- 저장 상태는 콘텐츠 헤더의 인디케이터가 담당(상단바 중복 표기 제거). -->
				<ThemeToggle />
				<div class="tw-h-4 tw-w-px tw-bg-border" />
				<AccountMenu showEmail={false} />
			</div>
		</header>
	{/if}

	<Route {currentRoute} {params} />
	<!-- 게시 설정 팝업. <Route/> 뒤에 두는 이유는 빌더 미리보기 드로어가 같은 z-index(1000)라
	     앞에 두면 좁은 화면에서 드로어가 팝업 위를 덮기 때문이다(같은 층은 뒤에 온 쪽이 이김).
	     ⚠️ .lite-wrap 에 deactivePublishPopup 클릭 핸들러가 걸려 있어서, 팝업 내용을 클릭하면
	        이벤트가 거기까지 올라가 팝업이 그대로 닫힌다. → 본문/푸터에서 전파를 끊는다.
	        (Dialog 의 오버레이·닫기 버튼은 어차피 닫는 동작이라 올라가도 무해) -->
	{#if !$isCreepong}
		<Dialog
			open={$isPublishPopup}
			title="AI챗 생성 설정"
			on:close={deactivePublishPopup}
		>
			<div class="tw-space-y-5 tw-font-sans" on:click|stopPropagation>
				{#if publishedJustNow}
					<div
						class="tw-rounded-md tw-border tw-border-primary/30 tw-bg-primary/10 tw-px-3 tw-py-2.5 tw-text-sm tw-text-foreground"
						role="status"
					>
						게시했어요! 아래 주소로 바로 확인할 수 있어요.
					</div>
				{/if}

				<section class="tw-space-y-2.5">
					<div class="tw-flex tw-items-center tw-justify-between tw-gap-2">
						<h3 class="tw-text-sm tw-font-semibold tw-text-foreground">AI챗 미리보기</h3>
						<Button
							variant="ghost"
							size="sm"
							on:click={() => window.open(pageUrl, "_blank")}
							disabled={!pageUrl}
						>
							<svg class="tw-h-4 tw-w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h6v6" /><path d="M10 14 21 3" /><path d="M21 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5" /></svg>
							AI챗 보러가기
						</Button>
					</div>
					<div class="tw-flex tw-items-center tw-gap-2">
						<Input
							type="text"
							class="tw-flex-1"
							value={pageUrl ?? ""}
							readonly
							aria-label="AI챗 주소"
						/>
						<Button variant="outline" size="sm" on:click={clickCopy} disabled={!pageUrl}>
							<svg class="tw-h-4 tw-w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="12" height="12" rx="2" /><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" /></svg>
							복사
						</Button>
					</div>
					{#if qrUrl}
						<div class="tw-flex tw-justify-center tw-rounded-lg tw-border tw-border-border tw-bg-muted/40 tw-p-3">
							<!-- QR은 어두운 배경에서도 읽혀야 하므로 흰 판 위에 둔다 -->
							<img
								class="tw-rounded tw-bg-white tw-p-1.5"
								src={qrUrl}
								width="100"
								height="100"
								alt="AI챗 주소 QR 코드"
							/>
						</div>
					{/if}
				</section>

				<div class="tw-h-px tw-bg-border" />

				<section class="tw-space-y-4">
					<h3 class="tw-text-sm tw-font-semibold tw-text-foreground">AI챗 설정</h3>

					<div class="tw-flex tw-items-start tw-justify-between tw-gap-4">
						<div class="tw-min-w-0">
							<div class="tw-text-sm tw-font-medium tw-text-foreground">공개여부</div>
							<p class="tw-mt-0.5 tw-text-xs tw-text-muted-foreground">AI챗의 공개 여부를 선택해 주세요!</p>
						</div>
						<Switch
							checked={isHomeOpenFlag === "Y"}
							on:click={changeHomeOpenFlag}
							aria-label="AI챗 공개여부"
						/>
					</div>

					<div class="tw-flex tw-items-start tw-justify-between tw-gap-4">
						<div class="tw-min-w-0">
							<div class="tw-text-sm tw-font-medium tw-text-foreground">AI챗 프로필 공개여부</div>
							<p class="tw-mt-0.5 tw-text-xs tw-text-muted-foreground">AI챗 프로필의 공개여부를 선택해주세요!</p>
						</div>
						<Switch
							checked={isCharacterUniverseOpenFlag === "Y"}
							on:click={changeCharacterUniverseOpenFlag}
							aria-label="AI챗 프로필 공개여부"
						/>
					</div>

					<div class="tw-flex tw-items-start tw-justify-between tw-gap-4">
						<div class="tw-min-w-0">
							<div class="tw-text-sm tw-font-medium tw-text-foreground">AI챗 프로필 배경 테마</div>
							<p class="tw-mt-0.5 tw-text-xs tw-text-muted-foreground">AI챗 프로필의 배경 테마를 선택할 수 있어요!</p>
						</div>
						<Tabs
							items={[
								{ key: "N", label: "화이트" },
								{ key: "Y", label: "블랙" },
							]}
							active={isDarkModeFlag === "Y" ? "Y" : "N"}
							on:change={(e) => setDarkMode(e.detail)}
						/>
					</div>
				</section>
			</div>

			<svelte:fragment slot="footer">
				<div class="tw-flex tw-items-center tw-gap-2 tw-font-sans" on:click|stopPropagation>
					<Button variant="outline" on:click={deactivePublishPopup}>닫기</Button>
					<Button on:click={() => doPosting()}>
						변경사항 반영
						{#if $isRevision}
							<span class="tw-h-1.5 tw-w-1.5 tw-rounded-full tw-bg-primary-foreground" title="게시되지 않은 변경사항이 있어요"></span>
						{/if}
					</Button>
				</div>
			</svelte:fragment>
		</Dialog>
	{/if}
</div>
